var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"slider",staticClass:"slider"},[_c('div',{staticClass:"process",style:({width: _vm.width})}),_vm._v(" "),_c('div',{ref:"trunk",staticClass:"thunk",style:({left: _vm.left})},[_c('div',{staticClass:"block"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f5d3731","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider.vue
// module id = null
// module chunks = 